import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cadastro-personalizado',
  templateUrl: './cadastro-personalizado.component.html',
  styleUrls: ['./cadastro-personalizado.component.css']
})
export class CadastroPersonalizadoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
